import { HttpParams } from '@angular/common/http';

export class HttpParamsMapper {
  static toHttpParams<T extends object>(
    input?: T,
    params: HttpParams = new HttpParams(),
    parentKey?: string
  ): HttpParams {
    if (!input) {
      return params;
    }

    for (const [key, value] of Object.entries(input)) {
      if (value === undefined || value === null) {
        continue;
      }

      const fullKey = parentKey ? `${parentKey}[${key}]` : key;

      if (typeof value === 'object') {
        if (Array.isArray(value)) {
          // Para arrays, usamos a mesma chave com valores múltiplos
          value.forEach((item) => {
            params = params.append(fullKey, String(item));
          });
        } else if (value instanceof Date) {
          // Tratamento especial para datas
          params = params.set(fullKey, value.toISOString());
        } else {
          // Recursão para objetos aninhados
          params = this.toHttpParams(value, params, fullKey);
        }
      } else {
        // Valores primitivos
        params = params.set(fullKey, String(value));
      }
    }

    return params;
  }
}
